import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import BssoPermissions from "components/LM/Bsso/Permissions";
import VoiceMSearchForm from "components/LM/Voice/MSearch/VoiceMSearchForm";

const MAX_SEARCH_RESULT_SIZE = 5;

function Search({ location }) {
  const history = useHistory();
  const [processing, setProcessing] = useState(false);

  let query = location.state;
  const onChange = (ev) => {
    history.replace(window.location.pathname, ev.target.value);
  };

  const onSubmit = (ev) => {
    ev.preventDefault();
    if (!query) return;
    const terms = cleanQuery(query);
    if (!terms.length) return;

    setProcessing(true);
    history.replace(window.location.pathname, query);
    history.push(window.location.pathname + '/results', { terms, maxSearchResultSize: MAX_SEARCH_RESULT_SIZE });
  };

  const cleanQuery = (query) => {
    return [...new Set(query.split("\n").filter(term => term !== ""))];
  }

  return (
		<BssoPermissions permissions={["voices.mass_search"]} behaviour="error">
			<VoiceMSearchForm query={query} processing={processing} onChange={onChange} onSubmit={onSubmit} />
		</BssoPermissions>
	)
}

export default Search;
